import React from "react";
import { useState } from "react";
import DashboardDetails from "./DashboardDetails";
import DashboardCountDetails from "./DashboardCountDetails";
import Pagination from "../Pagination";
import DateTimePicker from "react-datetime-picker";
import Popup from "../../helpers/Popup";
import { useDispatch, useSelector } from "react-redux";
import { setDishTimeServe } from "../../actions/adminActions";
const DisplayProductsAdmin = ({
  tableData,
  setTableData,
  headerTitle,
  tableHeaders,
  category,
}) => {
  const dispatch = useDispatch();
  const statusType = useSelector((state) => state.messageDetail);
  const [currentPage, setCurrentPage] = useState(1);
  const numberPerPage = 10;
  const indexOfLastArticle = currentPage * numberPerPage;
  const indexOfFirstArticle = indexOfLastArticle - numberPerPage;
  const paginate = (number) => setCurrentPage(number);
  const [value, onChange] = useState(new Date());
  const handleTimeToServe = async () => {
    dispatch({
      type: "SET_CANVAS",
      payload: { openCanvas: true, message: "Setting time..." },
    });
    const { msg } = await setDishTimeServe({
      timestamps: new Date(
        value.toLocaleString("en-US", { timeZone: "Asia/Manila" })
      ).getTime(),
    });
    dispatch({ type: "SET_MESSAGE", payload: msg });
  };

  return (
    <>
      <Popup />
      <div className="dashboard_detail_container">
        <div className="request-details">
          <div className="request_headers">
            <h2>{headerTitle}</h2>
            {headerTitle === "Daily Dishes" && (
              <div className="timerServing">
                <p className="detail_header">Set time serving: </p>
                <DateTimePicker onChange={onChange} value={value} />
                <button onClick={() => handleTimeToServe()}>SET</button>
              </div>
            )}
          </div>
          <table className="request-lists">
            <tbody>
              <tr>
                {tableHeaders.map((th) => {
                  return <th key={th}>{th}</th>;
                })}
              </tr>

              <DashboardDetails
                indexOfFirstArticle={indexOfFirstArticle}
                indexOfLastArticle={indexOfLastArticle}
                tableData={tableData}
                setTableData={setTableData}
                actions={["Display", "Hide", "Out of stock"]}
                discount={true}
                category={category}
                deletable={true}
                editable={true}
              />
            </tbody>
          </table>
          <Pagination
            numberPerPage={numberPerPage}
            totalArticles={tableData.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
    </>
  );
};

export default DisplayProductsAdmin;
